<template>
    <section class="relative overflow-hidden">
        <div class="container">
            <AtomTitle class="max-w-screen-lg">
                {{ title }}
            </AtomTitle>
        </div>
        <OurCustomersItems
            :class="indentAfterLine ? 'py-10 md:py-30' : 'pt-10 md:pt-30'" />
        <div
            v-if="!hideAboutButton"
            class="container text-center">
            <BaseLink
                to="/media"
                target="_blank"
                icon-right="arrow-right"
                size="accent">
                О нас в СМИ
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'

import OurCustomersItems from './OurCustomersItems.vue'

defineProps({
    hideAboutButton: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    indentAfterLine: {
        type: Boolean as PropType<boolean>,
        default: true,
    },
    title: {
        type: String as PropType<string>,
        default:
            'Надежность нашего оборудования обеспечена репутацией его пользователей',
    },
})
</script>
